import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface WorksheetSubmissionParams {
  formData: FormData;
}

export interface WorksheetSubmissionItem {
  scheduledclass_id: number;
  worksheet_id: number;
  total_marks?: number;
}

export interface WorksheetSubmissionState {
  data: {
    status?: boolean;
    message?: string;
    data?: any;
  } | null;
  isLoading: boolean;
  error: any;
}

const initialState: WorksheetSubmissionState = {
  data: null,
  isLoading: false,
  error: null,
};

const WorksheetSubmissionSlice = createSlice({
  name: "WorksheetSubmissionSlice",
  initialState,
  reducers: {
    submitWorksheet: (state, _action: PayloadAction<WorksheetSubmissionParams>) => {
      state.isLoading = true;
      state.error = null;
    },
    successWorksheetSubmission: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
    },
    failureWorksheetSubmission: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.data = null;
      state.error = action.payload;
    },
    resetWorksheetSubmission: (state) => {
      state.data = null;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  submitWorksheet,
  successWorksheetSubmission,
  failureWorksheetSubmission,
  resetWorksheetSubmission,
} = WorksheetSubmissionSlice.actions;

export default WorksheetSubmissionSlice.reducer;
